export function formatPhoneNumber(phoneNumber) {
	// Strip all non-digits
	const digits = phoneNumber.replace(/\D/g, '')
	if (digits.length === 11 && digits.startsWith('1')) {
		const areaCode = digits.substring(1, 4)
		const middle = digits.substring(4, 7)
		const last = digits.substring(7, 11)
		return `+1 (${areaCode}) ${middle}-${last}`
	} else {
		// Return the original if it doesn't meet expected format
		return phoneNumber
	}
}
